'use client'

import { buttonVariants } from '@/components/Button'
import { I18NText } from '@/components/I18NText'
import { Heading } from '@/components/Typography/Heading'
import { Paragraph } from '@/components/Typography/Paragraph'
import { cn } from '@/lib'
import { useIsPasskeySupported } from '@/lib/useIsPasskeySupported'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { signIn } from '../actions'
import { EmailForm } from './EmailForm'
import { PasskeyLogin } from './PasskeyLogin'

interface Props {
	showSelfService: boolean
	recaptchaSiteKey: string
}

export const SignInForm: React.FC<Props> = ({
	showSelfService,
	recaptchaSiteKey,
}) => {
	const [success, setSuccess] = useState(false)
	const passkeyAvailable = useIsPasskeySupported()
	const searchParams = useSearchParams()

	return (
		<div className="flex flex-col gap-6">
			{!success && showSelfService && (
				<div className="flex flex-col items-center gap-4">
					<Heading level="1">
						<I18NText text="login.title" />
					</Heading>
					<Paragraph>
						<I18NText text="login.createAccount" />{' '}
						<Link
							href={{
								pathname: '/register',
								search: searchParams.toString(),
							}}
							className={cn(
								buttonVariants({ variant: 'text' }),
								'px-0 text-inherit',
							)}
						>
							<I18NText text="login.cta" />
						</Link>
					</Paragraph>
				</div>
			)}

			<EmailForm
				mode="login"
				action={signIn}
				onSuccess={() => setSuccess(true)}
				recaptchaSiteKey={recaptchaSiteKey}
			/>

			{passkeyAvailable && !success && <PasskeyLogin />}
		</div>
	)
}
